import { useState, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios, { endpoints } from 'src/utils/axios';

type Props = {
  children: ReactNode;
};

const SetupGuard = ({ children }: Props) => {
  const [checked, setChecked] = useState<Boolean>(false);
  const navigate = useNavigate();

  const validateFirstUser = async () => {
    axios
      .get(endpoints.validateFirstUser)
      .then((response) => {
        setChecked(response.data);
        response.data === false && navigate('/');
      })
      .catch((error) => {
        console.log(error);
        setChecked(false);
      });
  };

  useEffect(() => {
    validateFirstUser();
  }, [checked]);

  if (!checked) {
    return null;
  }

  return <>{children}</>;
};

export default SetupGuard;
